import React from 'react';
import './Project.scss';
import images from '../../constants/images';
import { BsFillCheckCircleFill, BsFillXCircleFill } from 'react-icons/bs';
import { TbClick } from 'react-icons/tb';
import { motion } from 'framer-motion';


const Project = () => {
  return (
    <div className='app__project app__bg flex__center section__padding' id='project'>
      <motion.div
      initial={{ opacity: 0, scale: 0 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{duration: 1}}
      className='app__project-infos flex__center'>
        <div className='flex__center app__project-infos_info'>
          <a href="https://masbrostock.netlify.app" target='_blank'>
            <h1 className='p__poppins'>Stock Tracker<TbClick/></h1>
          </a>
            <h5 className='p__opensans'>Side Note: Limited API</h5>
            <p className='p__opensans'><BsFillCheckCircleFill className='allowed'/> TSLA</p>
            <p className='p__opensans'><BsFillXCircleFill className='not__allowed'/> TSLA.NE</p>
        </div>

        <img src={images.project} alt="logo" />
      </motion.div>
    </div>
  )
}

export default Project